import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

export default {
  state: {
    segments: [],
    loading: false,
    error: false,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorSegments(state) {
      state.segments = [];
      state.loading = false;
      state.error = true;
    },
    setSegments(state, segments) {
      state.segments = segments;
      state.loading = false;
      state.error = false;
    },
  },
  actions: {
    async fetchSegments({ commit }, { onlyActive = false } = {}) {
      commit('fetch');
      try {
        const response = await backend.getUserSegments(onlyActive);
        await checkResponseStatus(200, response);
        commit('setSegments', response.data);
      } catch (error) {
        console.error(error);
        commit('errorSegments');
      }
    },
    async createSegment(context, { segment }) {
      const response = await backend.postUserSegment(segment);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async updateSegment(context, { segmentID, segment }) {
      const response = await backend.putUserSegment(segmentID, segment);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async deleteSegment(context, { segmentID }) {
      const response = await backend.deleteUserSegment(segmentID);
      await checkResponseStatus(204, response);
    },
  },
  namespaced: true,
};
